import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  HealthcareAddDonationPayload,
  HealthcareDonation,
} from "@project/types/healthcare-donation";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/healthcare-donations`;
const SILENT: RequestConfig = { showNotification: false };

class HealthcareDonationService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<HealthcareDonation>> =>
    fetchListPage<HealthcareDonation>(`${BASE}/`, query);

  get = async (id: number): Promise<HealthcareDonation | undefined> => {
    const data = await get<
      ApiItemResponse<HealthcareDonation> | HealthcareDonation
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  add = async (
    payload: HealthcareAddDonationPayload
  ): Promise<HealthcareDonation | undefined> => {
    const data = await post<
      ApiItemResponse<HealthcareDonation> | HealthcareDonation,
      HealthcareAddDonationPayload
    >(`${BASE}/add/`, payload, SILENT);
    return unwrapItem(data);
  };
}

export const healthcareDonationService = new HealthcareDonationService();
